// CarouselComponent.jsx
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Card, CardBody, Col, Row } from "reactstrap";
import "./BizzList.css";
import PlaceHolder from "../../../assets/images/Placeholder.png";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  checkExisting,
  handleActionClick,
  setActionType,
  setIsChatModalOpen,
  setSampleAd,
  setSearchPopUp,
  setShowCallDialog,
} from "../../../redux/slices/SearchBarSlice";
import { setEngagedCouple } from "../../../redux/slices/RequestFormSlice";

const CarouselComponent = ({ items }) => {
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const [phoneNumbers, setPhoneNumbers] = React.useState({}); // State to track phone numbers per item
  const isAdmin = user && user.Role === "admin";
  const isVendor = user && user.Role === "provider";
  const dispatch = useDispatch();

  const handleAction = async (e, action, ad) => {
    e.stopPropagation();
    dispatch(setSampleAd(ad));
    dispatch(setActionType(action));

    // If user is admin or vendor, show phone number for this specific ad
    if (isAdmin || isVendor) {
      setPhoneNumbers((prev) => ({
        ...prev,
        [ad.Id]: ad?.phone || "0", // Store phone number for this specific ad
      }));
      if (action === "CALL") {
        dispatch(setShowCallDialog(true));
      } else {
        dispatch(setIsChatModalOpen(true));
      }
      return;
    }

    // For non-admin/non-vendor users, check if the need exists
    let needExists = false;
    if (islogin) {
      const constructedTitle = ad?.list_name + " (Auto Generated)";
      const checkForm = {
        Title: constructedTitle,
        userId: user.UserID,
      };
      const result = await dispatch(checkExisting(checkForm)).unwrap();
      needExists = result.data;
    }

    // If need exists or user is logged in, handle the action
    if (needExists) {
      setPhoneNumbers((prev) => ({
        ...prev,
        [ad.Id]: ad?.phone || "0", // Store phone number for this specific ad
      }));
      if (action === "CALL") {
        dispatch(setShowCallDialog(true));
      } else {
        dispatch(setIsChatModalOpen(true));
      }
      return;
    }

    if (islogin) {
      const form = {
        userId: user.UserID,
        postId: ad.Id,
        postType: 2,
        clickType: action === "CALL" ? 1 : 2,
        createdBy: user.UserID,
      };
      dispatch(handleActionClick(form));
    }
    dispatch(setSearchPopUp(true));
    dispatch(setEngagedCouple(1));
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: items?.length > 1 ? 2 : 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          autoplay: true,
          autoplaySpeed: 3000,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          autoplay: true,
          autoplaySpeed: 3000,
          slidesToShow: items?.length > 1 ? 2 : 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 2400,
        settings: {
          autoplay: true,
          autoplaySpeed: 3000,
          slidesToShow: items?.length > 1 ? 2 : 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  };

  return (
    <Slider {...settings}>
      {items &&
        items.map((item, index) => (
          <Card key={index} className="carousel-item">
            <CardBody
              style={{ border: "none", padding: "10px", overflow: "hidden" }}
            >
              <Row>
                <Col sm={4}>
                  <div className="carousel-image">
                    <img
                      src={
                        item?.photo ? JSON.parse(item?.photo)[0] : PlaceHolder
                      }
                      alt={item.list_name}
                      style={{
                        width: "100%",
                        height: "150px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                </Col>
                <Col sm={8} style={{ padding: 0 }}>
                  <div
                    className="carousel-details text-start"
                    style={{
                      padding: 0,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      height: "150px",
                    }}
                  >
                    <div className="list_text" style={{ marginBottom: "8px" }}>
                      <h4
                        style={{
                          margin: "3px 0px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "wrap",
                          fontSize: "larger",
                        }}
                      >
                        {item?.Package
                          ? item?.list_name.length > 55
                            ? item?.list_name.substring(0, 55) + "..."
                            : item?.list_name
                          : item?.list_name.length > 55
                          ? item?.list_name.substring(0, 55) + "..."
                          : item?.list_name}
                      </h4>
                      <p
                        style={{
                          margin: "0",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "wrap",
                          fontSize: "small",
                        }}
                      >
                        {item?.description.length > 130
                          ? item?.description.substring(0, 130) + "..."
                          : item?.description}
                      </p>
                    </div>
                    <div
                      className="d-flex gap-1 list_button"
                      style={{
                        maxHeight: "50px",
                        height: "50px",
                        alignItems: "center",
                        justifyContent: "space-evenly",
                      }}
                    >
                      <>
                        <button
                          className="btn btn-sm btn-success bizz_buttons"
                          onClick={(e) => handleAction(e, "CALL", item)}
                        >
                          {phoneNumbers[item.Id] || "Show Phone Number"}
                        </button>
                        <button className="btn btn-sm btn-success text-white bizz_buttons">
                          <span>Extension # {item?.dial_extension}</span>
                        </button>
                      </>
                    </div>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        ))}
    </Slider>
  );
};

export default CarouselComponent;
